export enum GenerateLoanOffersSteps {
	BranchOffer = 'BranchOffer',
	NoCreditOffer = 'NoCreditOffer',
	OnlineOffer = 'OnlineOffer',
};

export enum BranchOfferType {
	Physical = 'Physical',
	Central = 'Central',
};

export enum BankAccountType {
	Existing = 'Existing',
	Other = 'Other',
};

export enum BranchOfferFlowSteps {
	SelectBranchOfferStep = 'SelectBranchOfferStep',
	PhysicalBranchOfferStep = 'PhysicalBranchOfferStep',
	CentralBranchOfferStep = 'CentralBranchOfferStep',
	ConnectBankAccountForFundingStep = 'ConnectBankAccountForFundingStep',
	BankInformationPlaid = 'BankInformationPlaid',
	BankInformationPlaidIntegrationWaiting = 'BankInformationPlaidIntegrationWaiting',
	BankInformationPLaidIntegrationFailed = 'BankInformationPLaidIntegrationFailed',
};

export enum NoCreditOfferFlowSteps {
	ConnectBankAccountInformationNeededStep = 'ConnectBankAccountInformationNeededStep',
	BankInformationPlaid = 'BankInformationPlaid',
	BankInformationPlaidIntegrationWaiting = 'BankInformationPlaidIntegrationWaiting',
	BankInformationPLaidIntegrationFailed = 'BankInformationPLaidIntegrationFailed',
	SelectOnlineLoanOffer = 'SelectOnlineLoanOffer',
	BankAccountSelectStep = 'BankAccountSelectStep',
	SetupAutoPayFillingOptionsStep = 'SetupAutoPayFillingOptionsStep',
	SetupAutoPayStep = 'SetupAutoPayStep',
};

export enum OnlineOfferFlowSteps {
  ConnectBankAccountForFundingStep = 'ConnectBankAccountForFundingStep',
  BankAccountExistingOrOtherAccount = 'BankAccountExistingOrOtherAccount',
  PhysicalBranchOfferStep = 'PhysicalBranchOfferStep',
  CentralBranchOfferStep = 'CentralBranchOfferStep',
  BankInformationPlaid = 'BankInformationPlaid',
  BankInformationPlaidIntegrationWaiting = 'BankInformationPlaidIntegrationWaiting',
  BankInformationPLaidIntegrationFailed = 'BankInformationPLaidIntegrationFailed',
  SelectOnlineLoanOffer = 'SelectOnlineLoanOffer',
  SelectSLRefiLoanOffer = 'SelectSLRefiLoanOffer',
  BankAccountSelectStep = 'BankAccountSelectStep',
  SetupAutoPayFillingOptionsStep = 'SetupAutoPayFillingOptionsStep',
  SetupAutoPayStep = 'SetupAutoPayStep',
  SelectPPCJourneyLoanOffer = 'SelectPPCJourneyLoanOffer',
  ApplicationIsNotApprovedNOAAStep = 'ApplicationIsNotApprovedNOAAStep',
};
